import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { VelocityTransitionGroup } from 'velocity-react';
import { selectDeadline } from './actions';
import { deadlinesForAccount, getSelectedDeadline } from './reducer';
import { getUserAccount } from '../user/selectors';
import { getPendingStatus } from '../util/requestReducer';
import { Spinner } from '../components';
import Sidebar from './Sidebar';
import DeadlineDetails from './DeadlineDetails';
import OrderWindow from './OrderWindow';

export class OrderDeadlines extends Component {
  constructor(props) {
    super(props);

    this.handleSidebarItemClick = this.handleSidebarItemClick.bind(this);
  }

  deadlinesHaveLoaded() {
    const { deadlines } = this.props;
    return Array.isArray(deadlines);
  }

  handleSidebarItemClick(item) {
    const { selectDeadline } = this.props;
    selectDeadline(item);
  }

  buildOrderDeadlines() {
    if (!this.deadlinesHaveLoaded()) return null;
    const { deadlines, selectedDeadline } = this.props;

    return (
      <div className='orderDeadlines__inner'>
        <Sidebar
          orderWindows={deadlines}
          selectedWindow={selectedDeadline}
          onSidebarItemClick={this.handleSidebarItemClick}
        />
        <DeadlineDetails deadline={selectedDeadline} />
      </div>
    );
  }

  render() {
    const { isLoading } = this.props;
    const transitionGroupProps = {
      enter: { animation: 'fadeIn', display: 'flex' },
      leave: { animation: 'fadeOut' },
      className: 'orderDeadlines'
    };

    return (
      <VelocityTransitionGroup {...transitionGroupProps}>
        {isLoading && <Spinner />}
        {this.buildOrderDeadlines()}
      </VelocityTransitionGroup>
    );
  }
}

OrderDeadlines.defaultProps = {
  account: null,
  deadlines: null,
  selectedDeadline: null
};

OrderDeadlines.propTypes = {
  account: PropTypes.shape({ number: PropTypes.string }),
  deadlines: PropTypes.arrayOf(PropTypes.instanceOf(OrderWindow)),
  isLoading: PropTypes.bool.isRequired,
  selectDeadline: PropTypes.func.isRequired,
  selectedDeadline: PropTypes.instanceOf(OrderWindow)
};

const mapStateToProps = state => {
  const account = getUserAccount(state);
  const deadlines = account && account.number ? deadlinesForAccount(state, account.number) : null;
  const selectedDeadline = getSelectedDeadline(state);

  return {
    account,
    deadlines,
    selectedDeadline,
    isLoading: getPendingStatus(state, 'GET_ORDER_DEADLINES')
  };
};

export default connect(mapStateToProps, {
  selectDeadline
})(OrderDeadlines);
